<!-- Modal Container -->
<template>
  <transition name="modal-fade" class="modal-fade">
    <div class="modal-backdrop">
      <form @submit.prevent="copyReengagement" action="#" method="post">
        <div class="copy-modal" role="dialog" ref="" aria-labelledby="modalTitle" aria-describedby="modalDescription"
        >
          <header class="modal-header">
            <slot name="header">
              Copy Reengagement
              <div class="closeButton">
                <!-- <button type="button" class="btn" @click="close">Close</button> -->
              </div>
            </slot>
          </header>
          <section class="copy-modal-body">
              <div class="form-horizontal">
            <div class="form-group">
              <label for="campaign" style="font-weight:500" class="col-sm-4 control-label">Current Reengagement Name</label>
              <div class="col-sm-8 control-label" style="text-align: left">
                <strong> {{ currentName }} </strong>
              </div>
            </div>
             <div class="form-group">
               <div class="col-sm-8 control-label" style="text-align: center">
                <strong class="text-red"> Reengagement can be copied to this instance only. </strong>
              </div>
            </div>
            <div class="form-group">
              <label for="campaign" style="font-weight: 500" class="col-sm-4 control-label required" >New Reengagement Name</label>
              <div class="col-sm-8 control-label" style="text-align: left">
                <input type="text" v-model="name" class="form-control" id="name" placeholder="New Reengagement Name"/>
                 <span v-if="submitted && !$v.name.required" class="text-red pull-right" >Please provide a reengagement name.</span>
                 <span v-if="submitted && name === currentName" class="text-red pull-right" >Please provide a new reengagement name.</span>
              </div>
            </div>

            <div class="form-group">
              <label for="campaign" style="font-weight: 500" class="col-sm-4 control-label" >Select Deployment Date</label>
              <div class="col-sm-8 control-label" style="text-align: left">
                <input :min="getDate()" v-bind:class="{'form-group--error': submitted && !$v.deploymentDate.required }" v-model="deploymentDate" type="date" class="form-control"/>
              <span v-if="submitted && !$v.deploymentDate.required" class="text-red pull-right" >Please choose a deployment date.</span>
              </div>
            </div>

            <div class="form-group">
              <label for="campaign" style="font-weight: 500" class="col-sm-4 control-label" >Select Deployment Time</label>
              <div class="col-sm-8 control-label" style="text-align: left">
                <input type="time" class="form-control" v-bind:class="{'form-group--error': submitted && !$v.deploymentTime.required, }" v-model="deploymentTime"/>
              <span v-if="submitted && !$v.deploymentTime.required" class="text-red pull-right" >Please choose a deployment date.</span>
              </div>
            </div>
            </div>
           
          </section>
          <footer class="copy-modal-footer">
            <slot name="footer">
              <button type="button" class="btn btn-primary" @click="close()">
                Cancel
              </button>
              <input type="submit" class="btn btn-primary" value="Copy" />
            </slot>
          </footer>
        </div>
      </form>
    </div>
  </transition>
  <!-- Modal Container end -->
</template>
<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment'
export default {
  name: 'copyModal',
  validations: {
    name: { required },
    deploymentDate: {
      required: requiredIf(function () {
        return this.deploymentTime
      })
    },
    deploymentTime: {
      required: requiredIf(function () {
        return this.deploymentDate
      })
    }
  },
  props: ['showCopyReengagementModal', 'currentName', 'restoredValues'],
  data () {
    return {
      submitted: false,
      name: '',
      deploymentDate: '',
      deploymentTime: ''
    }
  },
  methods: {
    close () {
      this.submitted = false
      this.$emit('close')
    },
    copyReengagement (e) {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid || this.currentName === this.name.trim()) {
        return
      }
      const scheduleData = {
        name: this.name,
        deploymentDate: this.deploymentDate,
        deploymentTime: this.deploymentTime
      }
      this.$emit('copyReengagement', scheduleData)
    },

    getDate () {
      return moment(new Date()).format('YYYY-MM-DD')
    }
  },
  mounted () {
    console.log('restoredValues', this.restoredValues)
    if (this.restoredValues) {
      this.name = this.restoredValues.name ? this.restoredValues.name : ''
      this.deploymentDate = this.restoredValues.deploymentDate ? this.restoredValues.deploymentDate : ''
      this.deploymentTime = this.restoredValues.deploymentTime ? this.restoredValues.deploymentTime : ''
    }
  }
}
</script>
<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.copy-modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 460px;    
  width: 700px;
}

.modal-header,
.copy-modal-footer {
  padding: 15px;
  display: inline-block;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  text-align: center;
  font-size: 18px;
}

.copy-modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
  margin-top: auto;
  text-align: end;
}

.copy-modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #0D9488;
  background: transparent;
}

.btn-green {
  color: white;
  background: #0D9488;
  border: 1px solid #0D9488;
  border-radius: 2px;
}
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
.closeButton {
  position: absolute;
  left: 92%;
  top: -1%;
  font-weight: bold;
}
.text-red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// copyModal.vue?b0658ef0